export interface AdminAccount {
  id: string; email: string; createdAt: string; lastLoginAt: string | null;
  loginCount: number; submissions: number; events: number; isAdmin: boolean;
}
export interface BlockedEmail { email: string; blockedAt: string }
export interface AdminOverview {
  accounts: AdminAccount[]; blocked: BlockedEmail[]; matchingAccounts: number; matchingBlocked: number;
  trackingStartedAt: string;
  totals: { accounts: number; events: number; logins: number; submissions: number; blocked: number; unreviewedLog: number };
}
/**
 * One saved failure for the Admin page's Log tab. `details` is the log line's JSON; `email` is the account it names;
 * `reviewedAt` is when an administrator marked it as looked at.
 */
export interface AdminLogEntry { id: number; at: string; source: string; details: string; email: string | null; reviewedAt: string | null }
export interface AdminLog { entries: AdminLogEntry[]; more: boolean }

/** A saved log line as a heading, a one-line summary and where it came from: the browser, or the server. */
export function describeLogEntry(entry: Pick<AdminLogEntry, 'source' | 'details'>) {
  let data: Record<string, unknown> = {};
  try { const parsed: unknown = JSON.parse(entry.details); if (parsed && typeof parsed === 'object') data = parsed as Record<string, unknown>; } catch { /* shown as saved */ }
  const errors = Array.isArray(data.errors) ? data.errors as { name?: unknown; message?: unknown }[] : [];
  const message = errors.length ? errors.map(error => [error.name, error.message].filter(part => typeof part === 'string' && part).join(': ')).join(' ← ') : '';
  if (entry.source === 'client error') return { origin: 'Browser', title: typeof data.where === 'string' ? data.where : entry.source, message };
  if (entry.source === 'server error') return { origin: 'Server', title: `${data.method ?? ''} ${data.route ?? ''}`.trim() || entry.source,
    message: [data.status, data.code].filter(part => part !== null && part !== undefined).join(' ') };
  return { origin: 'Server', title: entry.source, message };
}
